<template>
    <div v-if="isDev" style="background-color: red; text-align: center;">
        <strong>DEV Server <span v-if="git">{{ git.branch }}#{{ git.commit }}</span></strong>
    </div>
</template>

<script>
import Axios from 'axios'

export default {
  name: 'DevBanner',
  data: function () {
    return {
      isDev: process.env.NODE_ENV === 'development' || window.location.href.indexOf('https://dev.vosvoco.com/') >= 0 || window.location.href.indexOf('http://localhost') >= 0,
      git: null
    }
  },
  async created () {
    const rnd = Math.random() * 1000000
    const response = await Axios.get('/static/git.json?rnd=' + rnd.toString())
    this.git = response.data
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DevBanner.vue